import { render, staticRenderFns } from "./ShareToEdit.vue?vue&type=template&id=200676cf&scoped=true&"
import script from "./ShareToEdit.vue?vue&type=script&lang=js&"
export * from "./ShareToEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShareToEdit.vue?vue&type=style&index=0&id=200676cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200676cf",
  null
  
)

export default component.exports